import type { FunctionComponent } from "react";
import PhoneVerifyCommonPartial from "../../../partials/common/auth/phone-verify.common.partials";

export const PhoneVerifyCommonScreen: FunctionComponent = () => {
	return <PhoneVerifyCommonPartial />;
};
